import { parse, format, isValid } from 'date-fns';

export const parsePastedDate = (text) => {
  const formatsToTry = [
    'yyyy-MM-dd',                     // 2025-12-12 
    'dd-MM-yyyy',                     // 12-12-2025
    'MM-dd-yyyy',                     // 12-12-2025 (US style)
    'MM/dd/yyyy',                     // 12/12/2025 (US slashes)
    'dd/MM/yyyy',                     // 12/12/2025 (EU slashes)
    'yyyy/MM/dd',                     // 2025/12/12
    'yyyy.MM.dd',                     // 2025.12.12
    'dd.MM.yyyy',                     // 12.12.2025
    'MM.dd.yyyy',                     // 12.12.2025
    'yyyyMMdd',                       // 20251212 (compact)
    "yyyy-MM-dd'T'HH:mm:ss.SSSX",     // 2025-12-12T12:24:11.000Z
    "yyyy-MM-dd'T'HH:mm:ssX",         // 2025-12-12T12:24:11Z
    "yyyy-MM-dd'T'HH:mm:ss",          // 2025-12-12T12:24:11
    "yyyy-MM-dd'T'HH:mm",             // 2025-12-12T12:24
    "EEE, dd MMM yyyy",               // Mon, 12 Dec 2025
    "EEE MMM dd yyyy",                // Mon Dec 12 2025
    "MMMM dd, yyyy",                  // December 12, 2025
    "dd MMMM yyyy",                   // 12 December 2025
  ];

  for (const formatStr of formatsToTry) {
    const parsed = parse(text, formatStr, new Date());
    if (isValid(parsed)) {
      return format(parsed, 'yyyy-MM-dd');
    }
  }

  return '';
};